import validate from "/var/www/html/node_modules/nuxt/dist/pages/runtime/validate.js";
import clear_45error_45global from "/var/www/html/app/middleware/clear-error.global.ts";
import identity_45reconciliation_45global from "/var/www/html/app/middleware/identity-reconciliation.global.ts";
import route_45protection_45global from "/var/www/html/app/middleware/route-protection.global.ts";
import sanctum_58auth_58global from "/var/www/html/node_modules/nuxt-auth-sanctum/dist/runtime/middleware/sanctum.global.js";
import manifest_45route_45rule from "/var/www/html/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  clear_45error_45global,
  identity_45reconciliation_45global,
  route_45protection_45global,
  sanctum_58auth_58global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "auth-redirect": () => import("/var/www/html/app/middleware/auth-redirect.ts"),
  "redirect-verified-email": () => import("/var/www/html/app/middleware/redirect-verified-email.ts")
}